import Home from "../views/home.vue";
let routes = [
   // 注册
   {
    path: "/register",
    name: "register",
    component: () => import("../views/academic-headlines/register/index.vue"),
  },
  {
    path: "/",
    name: "home",
    redirect: "/academic-headlines",
    component: Home,
    children: [
      // 登录
      {
        path: "/login",
        name: "login",
        component: () => import("../views/login.vue"),
      },
      
      //发布快讯和文章
      {
        path: "/Release",
        name: "Release",
        component: () =>
          import("../views/academic-headlines/Release.vue"),
      },


      //文章详情
      {
        path: "/articleDetail",
        name: "ArticleDetail",
        component: () => import("../views/academic-headlines/article/detail.vue"),
      },

      //快讯详情
      {
        path: "/newsFlashDetail",
        name: "NewsFlashDetail",
        component: () =>
          import(
            "../views/academic-headlines/newsFlash/detail.vue"
          ),
      },
      // 资源详情
      {
        path: "/Resource_details",
        name: "Resource_details",
        component: () =>
          import(
            "../views/Resource_transactions/Resource_transactions/Resource_details/index.vue"
          ),
      },
      

      //资源下载
      {
        path: "/Resource_download", 
        name: "Resource_download",
        component: () =>
          import(
            "../views/Resource_transactions/Resource_transactions/Resource_download/index.vue"
          ),
      },

      
      //搜索
      {
        path: "/search",
        name: "search",
        component: () => import("../views/academic-headlines/search/index.vue"),
        children: [
          //以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          {
            path: "/contents", 
            name: "searchContent",
            component: () => import("../views/academic-headlines/search/article/index.vue"),
          },
          
          //搜索快讯
          {
            path: "/newsflashs", 
            name: "searchNewsflash",
            component: () =>
              import("../views/academic-headlines/search/news-flash/index.vue"),
          },
        ],
      },

     


      //资源交易
      {
        path: "/Resource",
        name: "Resource",
        redirect: "/resources_index",
        component: () => import("../views/Resource_transactions/index.vue"),
        children: [
          {
            path: "/resources_index",
            name: "resources_index",
            component: () =>
              import(
                "../views/Resource_transactions/resources_index/index.vue"
              ),
          },

          {
            path: "/Resource_theme",
            name: "Resource_theme",
            component: () =>
              import(
                "../views/Resource_transactions/resources_index/Resource_theme/index.vue"
              ),
          },
          {
            path: "/Resource_transactions",
            name: "Resource_transactions",
            component: () =>
              import(
                "../views/Resource_transactions/Resource_transactions/index.vue"
              ),
          },

          {
            path: "/my_Resource",
            name: "my_Resource",
            component: () =>
              import("../views/Resource_transactions/my_Resource/index.vue"),
            children: [
              // 我的资源
              {
                path: "/myresourxce",
                name: "myresourxce",
                component: () =>
                  import(
                    "../views/Resource_transactions/my_Resource/myresourxce/index.vue"
                  ),
              },
              //上传资源
              {
                path: "/mydownload",
                name: "mydownload",
                component: () =>
                  import(
                    "../views/Resource_transactions/my_Resource/mydownload/index.vue"
                  ),
              },
            ],
          },
        ],
      },
      
      //知识头条
      {
        path: "/academic-headlines", 
        name: "academic-headlines",
        redirect: "/index",
        component: () => import("../views/academic-headlines/index.vue"),
        children: [
          
          //知识头条首页 wc5.6
          {
            path: "/index",
            name: "index",
            component: () =>
              import("../views/academic-headlines/article/list.vue"),
          },

          //快讯 wc5.6
          {
            path: "/newsFlash", 
            name: "NewsFlash",
            component: () =>
              import("../views/academic-headlines/newsFlash/list.vue"),
          },
        ],
      },

      //个人中心
      {
        path: "/Personal",
        name: "Personal",
        redirect: "/myWz",
        component: () => import("../views/Personal Center/index.vue"),
        children: [
          //我的文章
          {
            path: "/myWz",
            name: "myWz",
            component: () =>
              import("../views/Personal Center/PCresourxce/myWz.vue"),
          },
          //我的快讯
          {
            path: "/myKx",
            name: "myKx",
            component: () =>
              import("../views/Personal Center/PCresourxce/myKx.vue"),
          },
          //我的资源
          {
            path: "/myZy",
            name: "myZy",
            component: () =>
              import("../views/Personal Center/PCresourxce/index.vue"),
          },

          // 我的账单
          {
            path: "/PCCollection",
            name: "PCCollection",
            component: () =>
              import("../views/Personal Center/PCCollection/index.vue"),
          },
          //账户设置
          {
            path: "/Basicinformation",
            name: "Basicinformation",
            component: () =>
              import(
                "../views/Personal Center/PCdata/Basic_information/index.vue"
              ),
          },
        ],
      },
    ]
  },
  {
    path: "/change_code", // 未登录 更改密码
    name: "change_code",
    component: () => import("../views/change_code/index.vue"),
  },
];

export default routes;
